<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
          <h3 class="text-center">Thème «{{ currentPerson.theme.name }}»</h3>
      </div>
    </div>
  <div class="row">
        <p style="text-align:center">Enregistrement(s) : {{ currentPerson.nbTexts.done + ' / ' + (currentPerson.nbTexts.total) + ' (' + (currentPerson.nbTexts.total - currentPerson.nbTexts.done) + ' restants)' }}</p>
  </div>
 <hr>
  <div class="row">
    <div class="col-md-12">
      <div class="media">
        <div class="media-left">
          <a href="#">
            <img v-if="currentPerson.picture" height="100px" width="100px" :src="getRemotePictureUrl()">              
            <img v-else class="media-object" src="../assets/img/personnage.png">
          </a>
        </div>
        <div class="media-body">
          <p class="text-left">Personnage : «{{ currentPerson.name }}»</p>
          <p class="text-left">Genre : {{ currentPerson.gender == 'MALE'? 'Homme' : 'Femme'}}</p>
          <p class="text-left" v-if="currentPerson.description != ''">Description : {{ currentPerson.description }}</p>
          <button class="btn btn-info btn-sm" type="button" @click="toggleUntoggleImport()">Importation texte</button>
          <button class="btn btn-info btn-sm" type="button" @click="toggleUntoggleVoiceGeneration(true)">Générer toutes les voix du personnage</button>
        </div>
        <br>
        <div class="form-group form-inline">
            <label class="form-label">Rechercher : </label>
            <input class="form-control" type="text" v-model="search" placeholder="Id ou texte">
        </div>
        <br>
<!--         <div class="form-group form-inline">
            <label class="form-label">Sans recordId</label>
            <input class="form-control" type="checkbox" v-model="withoutRecordIdOnly">
        </div> -->
      </div>
    </div>
  </div>
<hr>
<div class="row">
  <div class="col-md-12">
    <table class="table table-striped">
        <thead>
            <tr>
                <th>ID</th>
                <th class="col-md-2">Text ID</th>
                <!-- <th class="col-md-3">Record ID</th> -->
                <th class="col-md-5">Contenu / Prononciation</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody v-if="texts.length" class="list-group">
            <tr v-for="text in texts" :key="text.id" :class="[text.id == selectedTextId ? 'active' : '' , text.file ? 'list-group-item-success' : '' ]">
                <td v-html="text.id"></td>
                <td v-html="text.textId"></td>
                <!-- <td v-html="text.recordId"></td> -->
                <td @click="selectText(text)" v-html="showContent(text)"></td>
                <td>
                    <button class="btn btn-info btn-sm" type="button" @click="toggleUntoggleVoiceGeneration(false, text)">Générer la voix</button>
                    <button class="btn btn-info btn-sm" type="button" @click="toggleUntoggleRecord(text)">{{ (text.file ? 'Ecouter / ' : '') + 'Enregistrer' }}</button>
                    <router-link tag="button" class="btn btn-info btn-sm" type="button" :to="{ name: 'TextEdit', params: { themeId: $route.params.themeId, personId: currentPerson.id, textId: text.id } }">Editer</router-link>
                    <a download :href="textExportUrl(text)" v-if="text.file" class="btn btn-info btn-sm">Exporter</a>
                    <button class="btn btn-info btn-sm" type="button" @click="toggleUntoggleLinkPerson(text)">Lier à un autre personnage</button>
                    <button class="btn btn-info btn-sm" type="button" @click="toggleUntoggleDelete(text)">Supprimer</button>
                </td>
            </tr>
        </tbody>
        <tbody v-else>
        <tr>
            <td>
                Aucun texte.
            </td>
        </tr>
        </tbody>
    </table>
    <div class="pager"></div>
  </div>
</div>
    <modal effect="fade" :title="voiceGenerationModalTitle" :value="showVoiceGenerationModal" cancel-text="Annuler" ok-text="Générer" @ok="!personVoicesGeneration ? generateVoice() : generateVoices()" @cancel="toggleUntoggleVoiceGeneration()" :backdrop="backdropEnabled">
        <voice-selection v-if="showVoiceGenerationModal" ref="voiceSelection" :text="modalText.pronunciation || 'Ceci est un test.'" :voicePreset="voicePreset"></voice-selection>
        <br>
        <br>
    </modal>
    <modal effect="fade" :title="linkPersonModalTitle" :value="showLinkPersonModal" cancel-text="Annuler" ok-text="Lier" @ok="updateTextPerson()" @cancel="toggleUntoggleLinkPerson()">
        <div class="form-group" @keyup.enter="updateTextPerson()">
            <label>Personnage : </label>
            <typeahead
            :placeholder="linkPersonPlaceholder"
            v-model="selectedLinkPerson.name"
            async-key="persons"
            :async="typeaheadSource"
            :template="typeaheadTemplate"
            :on-hit="typeaheadCallback"
            ></typeahead>
        </div>
        <div style="color:red;" v-if="requiredPerson">
            Vous devez choisir un personnage.
        </div>
    </modal>
    <modal effect="fade" :title="recordModalTitle" :value="showRecordModal" cancel-text="Retour" ok-text="Ok" @ok="toggleUntoggleRecord()" @cancel="toggleUntoggleRecord()" :backdrop="backdropEnabled">
        <record ref="recorder" :text="modalText" @upload="onUpload()" @uploadFail="onUploadFail()"></record>
        <div slot="modal-footer"></div>
    </modal>
    <modal effect="fade" :title="importModalTitle" :value="showImportModal" cancel-text="Annuler" ok-text="Importer" @ok="toggleUntoggleImport()" @cancel="toggleUntoggleImport()">
        <importTextFiles :modal-person="currentPerson" @importSuccess="onImportSuccess"></importTextFiles>
        <div slot="modal-footer"></div>
    </modal>
    <modal effect="fade" :title="deleteModalTitle" :value="showDeleteModal" cancel-text="Annuler" ok-text="Supprimer" @ok="deleteText()" @cancel="toggleUntoggleDelete()">
        <div v-html="deleteModalText">
        </div>
    </modal>
</div>
</template>


<script>
    import { input as BsInput, modal as Modal, typeahead as Typeahead }  from 'vue-strap'
    import ImportTextFiles from 'components/ImportTextFiles'
    import Record from 'components/Record'
    import Listening from 'components/Listening'
    import VoiceSelection from 'components/VoiceSelection';

    export default {
        components: {
            Modal,
            BsInput,
            Typeahead,
            ImportTextFiles,
            Record,
            Listening,
            VoiceSelection
        },
        computed: {
            currentPerson: function() {
                return this.$store.state.admin.currentPerson;
            },
            texts: function() {
                return this.search != '' || this.withoutRecordIdOnly ? this.currentPerson.texts.filter((text) => (this.withoutRecordIdOnly ? !text.recordId : true) && (text.id.toString().includes(this.search.toLowerCase()) || text.content.toLowerCase().includes(this.search.toLowerCase()) || text.textId.toLowerCase().includes(this.search.toLowerCase()) || text.recordId.toLowerCase().includes(this.search.toLowerCase()))) : this.currentPerson.texts;
            },
            importModalTitle: function()  {
                return "Importer des fichiers pours le personnage \"" + this.currentPerson.name + "\"";
            },
            deleteModalTitle: function()  {
                return "Suppression du texte \"" + this.modalText.content + "\"";
            },
            recordModalTitle: function()  {
                return "Enregistrement du texte \"" + this.modalText.content + "\"";
            },
            voiceGenerationModalTitle: function()  {
                if (!this.personVoicesGeneration) {
                    return "Génération de la voix du texte \"" + this.modalText.content + "\"";
                }
                return "Génération des voix du personnage \"" + this.currentPerson.name + "\"";
            },
            linkPersonModalTitle: function()  {
                return "Lier \"" + this.modalText.content + "\" à un autre personnage";
            },
            deleteModalText: function()  {
                return "Confirmez-vous la suppression du texte \"" + this.modalText.content + "\" ?";
            },
            linkPersonPlaceholder: function() {
                return this.currentPerson.name;
            },
            typeaheadSource: function() {
                return this.$store.state.baseUrl + "/admin/theme/" + this.$route.params.themeId + "/persons/1/OTHER?token=" + this.$store.state.token + "&hint=";
            }
        },
        methods: {
            generateVoice() {
                let self = this;
                this.$store.dispatch('generateVoiceForText', {
                    textId: this.modalText.id,
                    textToSpeechData: this.$refs.voiceSelection.voiceOptions,
                    callbacks: {
                        success(textUpdated) {
                            self.$store.commit('VOICE_PRESET_ADDED', Object.assign(self.$refs.voiceSelection.voiceOptions, {id: -1}));
                            self.$store.commit('TEXT_UPDATED', {textToUpdate: self.modalText, newData: {voicePreset: self.$refs.voiceSelection.voiceOptions}});
                            self.$store.commit('ALERT_DATA_UPDATED', {
                                text: "La génération de la voix a été faite avec succès.",
                                type: 'success'
                            });
                            Object.assign(self.modalText, textUpdated);

                            self.toggleUntoggleVoiceGeneration();
                        }
                    }
                });
            },
            generateVoices() {
                let self = this;
                this.$store.dispatch('generateVoicesForPerson', {
                    personId: this.$route.params.personId,
                    textToSpeechData: this.$refs.voiceSelection.voiceOptions,
                    callbacks: {
                        success(personId) {
                            self.$store.commit('VOICE_PRESET_ADDED', Object.assign(self.$refs.voiceSelection.voiceOptions, {id: -1}));
                            self.$store.commit('ALERT_DATA_UPDATED', {
                                text: "La génération des voix du personnage a été faite avec succès.",
                                type: 'success'
                            });
                            self.$store.dispatch("getPersonDetail", {
                                personId: personId,
                                callbacks: {
                                    success: (data) => {
                                        self.$store.commit("CURRENT_PERSON_UPDATED", { data: data });
                                        next();
                                    },
                                    fail: () => {
                                        next("/");
                                    },
                                    error: () => {
                                        next("/");
                                    }
                                }
                            });
                            self.toggleUntoggleVoiceGeneration();
                        }
                    }
                });
            },
            getRemotePictureUrl()  {
                return process.env.API_URL.replace('/app_dev.php', '') + '/' + this.currentPerson.picture + '?ts=' + Date.now();
            },
            updateTextPerson()  {
                if (!this.selectedLinkPerson.name)  {
                    this.requiredPerson = true;
                    return ;
                }

                let successCallback = () => {
                    this.toggleUntoggleLinkPerson();
                    this.$store.dispatch('getPersonDetail', {
                        personId: this.$route.params.personId,
                        callbacks: {
                            success: (data) => {
                                this.$store.commit("CURRENT_PERSON_UPDATED", {data: data});
                                this.$store.commit('ALERT_DATA_UPDATED', {
                                    text: "La liaison du personnage avec le texte a été faite avec succès.",
                                    type: 'success'
                                });
                            }
                        }
                    });
                };
                this.$store.dispatch('linkPersonToText', {
                    textId: this.modalText.id,
                    newPerson: this.selectedLinkPerson,
                    callbacks: { success: successCallback,
                                 fail: this.toggleUntoggleLinkPerson,
                                 error: this.toggleUntoggleLinkPerson }
                });
            },
            textExportUrl(text)    {
                return this.$store.state.baseUrl + '/admin/text/' + text.id + '/export?token=' + this.$store.state.token;
            },
            toggleUntoggleVoiceGeneration(generationForPerson, text)  {
                this.personVoicesGeneration = generationForPerson;
                if (text)  {
                    this.modalText = text;
                }
                if (!this.showVoiceGenerationModal) {
                    this.voicePreset = (!generationForPerson ? text.voicePreset : (this.currentPerson.voicePreset ? Object.assign({}, this.currentPerson.voicePreset) : null)); 
                }

                this.showVoiceGenerationModal = !this.showVoiceGenerationModal;
            },
            toggleUntoggleRecord(text)  {
                if (text)  {
                    this.modalText = text;
                    this.$refs.recorder.cleanSounds();
                    this.$refs.recorder.initSavedFile();
                }
                this.showRecordModal = !this.showRecordModal;
            },
            toggleUntoggleImport(text)  {
                if (text)  {
                    this.modalText = text;
                }
                this.showImportModal = !this.showImportModal;
            },
            toggleUntoggleDelete(text)  {
                if (text)  {
                    this.modalText = text;
                }
                this.showDeleteModal = !this.showDeleteModal;
            },
            toggleUntoggleLinkPerson(text)  {
                this.requiredPerson = false;
                if (text)  {
                    this.selectedLinkPerson = {name: null};
                    this.modalText = text;
                }
                this.showLinkPersonModal = !this.showLinkPersonModal;
            },
            selectText(text)    {
                this.selectedTextId = text.id;
            },
            showContent(text)   {
                if (text.id == this.selectedTextId){
                    return text.content + (text.pronunciation && text.content != text.pronunciation ? ("<br>----<br>" + text.pronunciation) : '');
                }
                return text.content.substring(0, 80) + (text.content.length > 80 ?  '...' : '') + (text.pronunciation && text.content != text.pronunciation ? ("<br>----<br>" + text.pronunciation.substring(0, 80) + (text.pronunciation.length > 80 ?  '...' : '')) : '');
            },
            deleteText() {
                let successCallback = () => {
                    this.toggleUntoggleDelete();
                    this.$store.dispatch('getPersonDetail', {
                        personId: this.$route.params.personId,
                        callbacks: {
                            success: (data) => {
                                this.$store.commit("CURRENT_PERSON_UPDATED", {data: data});
                                this.$store.commit('ALERT_DATA_UPDATED', {
                                        text: 'Le texte «' + this.modalText.content + '» a été supprimé avec succès.',
                                        type: 'success'
                                });
                            }
                        }
                    });
                };
                this.$store.dispatch('deleteText', {
                    textToDelete: this.modalText,
                    callbacks: {
                        success: successCallback,
                        fail: this.toggleUntoggleDelete,
                        error: this.toggleUntoggleDelete
                    }
                });
            },
            onUpload()   {
                if (this.showRecordModal)   {
                    this.toggleUntoggleRecord();
                }
            },
            prepareNotImportedText(notImported)    {
                let str = "\n\nCertains des textes n'ont pas été importés car déja présents ou la référence est inexistante.\n";
                console.log(notImported);
                for (let file in notImported)   {
                    str += "\n" + file + " : \n\n";
                    for (let text of notImported[file])  {
                        str += "- '" + text.entry + "' à la ligne " + text.line + "\n";
                    }
                }
                console.log(str);
                return str;
            },
            onImportSuccess(notImported)   {
                this.toggleUntoggleImport();
                this.$store.dispatch('getPersonDetail', {
                    personId: this.$route.params.personId,
                    callbacks: {
                        success: (data) => {
                            this.$store.commit("CURRENT_PERSON_UPDATED", {data: data});
                            this.$store.commit('ALERT_DATA_UPDATED', {
                                    text: 'Les fichiers ont été importés avec succès.' + (!notImported ? '' : this.prepareNotImportedText(notImported)),
                                    type: 'success'
                            });
                        }
                    }
                });
            },
            onUploadFail()  {
                if (this.showRecordModal)   {
                    this.toggleUntoggleRecord();
                }
                this.$store.commit('ALERT_DATA_UPDATED', {
                        text: "L'enregistrement du son a échoué.",
                        type: 'danger'
                });
            },
            typeaheadCallback(item) {
                this.selectedLinkPerson = item;
                return item.name;
            }
        },
        data: function()  {
            return {
                showLinkPersonModal: false,
                showVoiceGenerationModal: false,
                showRecordModal: false,
                showImportModal: false,
                showDeleteModal: false,
                cancelTextModal: "Annuler",
                modalTextIndex: 0,
                modalText: {
                    recordId: 0,
                    content: ""
                },
                selectedTextId: 0,
                backdropEnabled: false,
                typeaheadTemplate: "{{ item.name }}",
                selectedLinkPerson: {
                    name: null
                },
                requiredPerson: false,
                search: '',
                withoutRecordIdOnly: false,
                voicePreset: {},
                personVoicesGeneration: false
            };
        },
        beforeCreate()  {
            this.$emit('navbarUpdate', {
                text: 'Retour aux personnages',
                pathData: {
                    name: "PersonList",
                    params: {
                        themeId: this.$route.params.themeId
                    }
                }
            });
        }
    };
</script>

<style>


</style>
